export default "__VITE_ASSET__DQEmzMBv__"